import './App.scss';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { ToastContainer } from './components/Toast';
import { EntitlementsProvider } from './contexts/entitlementsContext';
import { AppRoutes } from './routes/AppRoutes';
import { ScrollToTop } from './routes/ScrollToTop';

const App = () => (
  <>
    <ScrollToTop />
    <EntitlementsProvider>
      <Navbar />
      <AppRoutes />
    </EntitlementsProvider>
    <Footer />
    <ToastContainer />
  </>
);

export default App;
